import React from 'react';
import { Box, Typography, Card, CardContent, Grid, Button, Tooltip, } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import CorouselImages from '../customComponents/carouselImages';
import config from '../config.json';
import 'react-alice-carousel/lib/alice-carousel.css';

function CardData(data, volenteersCount, totalCredExchange) {

  const userID = parseInt(localStorage.getItem('userID'));
  const token = localStorage.getItem('token');
  let index = 0;
  return (
    <>
      <Grid container>
        <Grid item
          xs={12}
          sm={12}
          md={5}
          style={{ marginLeft: 20, marginTop: 20 }}
        >
          <Typography gutterBottom variant='h5' component='div'>
            Program Name  : {data[index].ProgramName}
          </Typography>
          <Typography gutterBottom variant='h6' component='div'>
            {data[index].ProgramDescription}
          </Typography>
          <Typography gutterBottom variant='h6' component='div'>
            Founder Name : {data[index].FounderName}
          </Typography>
          <Typography gutterBottom variant='h6' component='div'>
            Start Date : {data[index].StartDate}
          </Typography>
          <Typography gutterBottom variant='h6' component='div'>
            Total volunteers: {volenteersCount}
          </Typography>
          <Typography gutterBottom variant='h6' component='div'>
            Time cred$ exchanged : {totalCredExchange}
          </Typography>

          {parseInt(data[index].FounderId) === userID ? (
            <Button
              style={{
                backgroundColor: config[process.env.REACT_APP_HOST_NAME].css.buttonColor,
                color: config[process.env.REACT_APP_HOST_NAME].css.buttonFontColor,
                height: 40,
                marginTop: 20,
                marginBottom: 20,
                marginRight: 20,
              }}
              onClick={() => {
                window.location.href = `/edit/program/${data[index].ProgramId}`;
              }}
            >
              <Tooltip title='Edit program '>
                <EditIcon></EditIcon>
              </Tooltip>
            </Button>
          ) : (
            <></>
          )}

          {/* {data[index].FounderId === userID ? ( */}

          {token ? (
            <Button
              onClick={() => {
                window.location.href = `/event/create/${data[index].ProgramId}`;
              }}
              style={{
                backgroundColor: config[process.env.REACT_APP_HOST_NAME].css.buttonColor,
                color: config[process.env.REACT_APP_HOST_NAME].css.buttonFontColor,
                height: 40,
                marginTop: 20,
                marginBottom: 20,
                marginRight: 20,
              }}
            >
              <Typography gutterBottom component='div'>
                create event
              </Typography>
            </Button>
          ) : (
            <></>
          )}

          {/* <Button
            onClick={() => {
              window.location.href = `/program/creds/${data[index].ProgramId}`;
            }}
            style={{
              backgroundColor: config[process.env.REACT_APP_HOST_NAME].css.buttonColor,
              color: config[process.env.REACT_APP_HOST_NAME].css.buttonFontColor,
              height: 40,
              marginTop: 20,
              marginBottom: 20,
            }}
          >
            <Typography component='div'>Creds</Typography>
          </Button> */}
        </Grid>
        {
          window.innerWidth > 900 ?
            <Grid item sm={12} xs={12} md={6} style={{ marginLeft: 20, marginTop: 20 }}>
              <Grid container>
                {eventImages(data[index].Event, data[index].ProgramImages)}
              </Grid>
            </Grid> : <Grid item sm={12} xs={12} md={6} style={{ marginLeft: 0, marginTop: 20 }}>
              <Grid container>
                {eventImages(data[index].Event, data[index].ProgramImages)}
              </Grid>
            </Grid>}
      </Grid>

      <Card>{EvnetCardData(data[index].Event)}</Card>
    </>
  );

}
function eventImages(Event, Program) {

  let newImageArray = [];

  for (let i = 0; i < Program.length; i++) {
    newImageArray.push(Program[i]);
  }

  if (Event.length > 0) {
    Event.map((value) =>
      value.EventImages?.length > 0 && value.EventImages.forEach((element) => {
        newImageArray.push(element);
      })
    );
  }


  if (newImageArray.length > 0) {
    return (
      <Grid container>
        <Grid item sm={12} xs={12} md={12}>
          <div style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "10px"
          }}>
            <CorouselImages PhotoGallery={newImageArray} />

          </div>
        </Grid>
      </Grid>

    );
  } else {
    return <></>;
  }
}
function EvnetCardData(events) {
  const token = localStorage.getItem('token');
  const pointer = { cursor: 'pointer' };
  events.sort((a, b) => new Date(b.StartDate) - new Date(a.StartDate));
  return (
    <Grid container justifyContent='center' spacing={4}>
      {events.map((value) =>
        value.ActStatus ? (
          <Grid xs={12} sm={6} md={6} key={value.EventID} item>
            <Box
              border={1}
              borderRadius="16px"
              m={2}
              spacing={4}
              style={pointer}
              onClick={() => {
                if (token !== undefined) {
                  window.location.href = `/event/${value.EventID}`;
                } else {
                  window.location.href = `/program/event/${value.EventID}`;
                }
              }}
            >
              <CardContent>
                <Typography gutterBottom variant='h5' component='div'>
                  {value.Title}
                </Typography>
                <Typography variant='caption'>
                  {value.EventDescription}
                </Typography>
                <br />
                <Typography variant='caption'>
                  Start Date : {value.StartDate}
                </Typography>
                <br />
                <Typography variant='caption'>
                  End Date : {value.EndDate}
                </Typography>
              </CardContent>
            </Box>
          </Grid>
        ) : (
          <div key={value.EventID}></div>
        )
      )}
    </Grid>
  );
}

export default function EventCard(props) {


  if (props.eventData) {
    return (
      <>
        <Box sx={{ flexGrow: 1 }}>
          <Grid>{CardData(props.eventData, props.volCount, props.totalCredExchange)}</Grid>
        </Box>
      </>
    );
  } else {
    return (
      <>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xs={6} md={6}>
              No Events
            </Grid>
          </Grid>
        </Box>
      </>
    );
  }
}
